import $ from "jquery"
import _ from "underscore"
import ProjectPanel, {ProjectPanelDialogs} from "./ProjectPanel"
import makeRpcCall from "../../util/jquery_rpc"
import messageResource from "../../messageResource"
import ProjectStore from "../../store/ProjectStore"
import CustomerStore from "../../store/CustomerStore"
import AuditHistoryView from "../auditHsitory/AuditHistoryView"
import {projectActionsProvider} from "../actionsProviders"
import {applyActionResultToAssignedUsersEditor} from "../applyAction"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from "../errors"
import {selectFirstStatusByType, selectStatusById} from "../../workflowStatus/selectors"
import {connect, unsafe_selectWithState} from "../../redux/utils"
import {WorkflowStatusType} from "../../workflowStatus/constants"
import PanelContainer from "../../components/PanelContainer"
import LoadingContainer from "../../util/LoadingContainer"
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from "../constants"
import {resolveAuditActions} from "../utils"
import {AuditEntityTypes} from "../auditHsitory/constants"
import UserNameFormat from '../../util/UserNameFormat'
import {Feature, isEnabled} from "../../features"
import {arrayToSet} from '../../atUtils'
import StateComponent from '../../StateComponent'
import {copyLinkTo, reloadComments, setAllTasksAssigned, setCanManageProject} from './actions'
import {bindActionCreators} from 'redux'
import {
    CUSTOMER_ARCHIVED_EXCEPTION,
    CUSTOMER_UNAVAILABLE_EXCEPTION,
    NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION,
    NO_SUCH_CUSTOMER_EXCEPTION,
    NO_SUCH_PROJECT_EXCEPTION,
    PROJECT_EXISTS_EXCEPTION,
    PROJECT_IS_NOT_ASSIGNED_EXCEPTION
} from '../../taskManagement/common/ExceptionsTypes'
import {addCustomer} from '../../entities/actions'
import {archiveProjectAndReloadTasks, removeCustomer, removeProject, updateProject} from '../../taskManagement/common/actions'
import {getOpenProjectId, isPanelOpenedFromUrl} from './selectors'
import {setEnabledFeatures} from '../../features/actions'
import {isWASEnabled} from '../../features/selectors'
import {toast, warning} from '../../toasts/actions'

class ProjectPanelController extends StateComponent {
    constructor({
        updateProject = () => {},
        onProjectArchivedCb = () => {},
        onProjectDeletedCb = () => {},
        onCustomerChangedCb = () => {},
        onCustomerDeletedCb = () => {},
        setAllTasksAssigned = () => {},
        setCanManageProject = () => {},
        updateEnabledFeatures = () => {},
        loadComments = () => {},
        copyLink = () => {},
        toast = () => {},
        warning = () => {},
    }) {
        super()

        this.state = {
            projectId: null,
            openedFromUrl: false,

            name: "",
            description: "",
            status: false,
            creationTimestamp: null,
            allAuditHistoryLoaded: false,

            isWASEnabled: false,
        }

        this.actions = {
            updateProject,
            onProjectArchivedCb,
            onProjectDeletedCb,
            onCustomerChangedCb,
            onCustomerDeletedCb,
            setAllTasksAssigned,
            setCanManageProject,
            updateEnabledFeatures,
            loadComments,
            copyLink,
            toast,
            warning,
        }

        this.onStatePropertyChanged('projectId', (projectId, prevProjectId) => {
            this.panelContainer.setState({isShown: projectId !== null})
            if (projectId && projectId !== prevProjectId) {
                this.loadData(projectId)
            }
        })
    }

    init() {
        const $taskBlock = $("#taskListBlock");
        const $page = $('#taskManagementPage');

        this.panel = new ProjectPanel({
            updateDescription: description => this._updateDescription(description),
        });
        this.loadingContainer = new LoadingContainer({
            $containerEl: null,
            contentComponent: this.panel,
            containerClass: "",
            proxySetState: false,
        })
        this.panelContainer = new PanelContainer({
            component: this.loadingContainer,
            showCopyLink: true,
            copyLinkTooltipText: messageResource.getMessage('project.edit_panel.copy_link_tooltip_text'),
            showHideButton: true,
            additionalClass: 'edit_project_sliding_panel sliding_panel',
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_RIGHT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_RIGHT,
            onClickCloseButton: () => this.panelContainer.setState({isShown: false}),
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                outsideElement:  $page,
                panelType: PANEL_TYPES.EDIT_PROJECT,
            },
            onShowCallback: () => {
                this.panel.onShow()
            },
            onHideCallback: () => {
                this._abortLoadPanelRequest()
                this.projectId = null
                this.panel.onHide()
            },
            onCopyLinkClick: () => this.actions.copyLink(),
            hideHandler: () => this.panelContainer.setState({isShown: false}),
        }).init($taskBlock)

        this.subscribeForEvents();
        return this;
    }

    subscribeForEvents() {
        const panel = this.panel;

        panel.header.nameInput.on('change', (e, name) => {
            const projectId = this.projectId;
            projectId && this._makeUpdateRequest("ProjectInfoService.updateProjectName", "name", name, panel.header.nameInput,
                    () => {},
                    () => {
                        panel.setState({name})
                        this._updateProjectInStore(projectId)
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        if (errorThrown.exception === 'com.actimind.actitime.project.ProjectExistsException') {
                            this.panel.header.nameInput.setState({
                                invalid: true,
                                focus: true,
                                errorText: messageResource.getMessage("project.edit.project_name_exists")
                            })
                            return true;
                        }
                        return false;
                    });
        });

        panel.on('delete', (e, revokeStatuses) => {
            const projectId = this.projectId;
            const customErrorHandler = (jqXHR, textStatus, errorThrown) => {
                if (projectId !== this.projectId)
                    return false;

                if (errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
                    alert(messageResource.getMessage("project.edit.cannot_delete_due_to_lock_time"));
                    panel.header.actions.disableDeleteButton(messageResource.getMessage("project.edit.cannot_delete_due_to_lock_time"));
                    panel.openLastSelectedTab()
                    return true;
                }
                if (errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
                    alert(messageResource.getMessage("project.edit.cannot_delete_due_to_unavailable_to_modify"));
                    panel.header.actions.disableDeleteButton(
                            messageResource.getMessage("hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time",
                                    [messageResource.getMessage("common.project")]));
                    panel.openLastSelectedTab()
                    return true;
                }
                return false;
            };

            $(this).trigger("deleteBegin");
            makeRpcCall("ProjectInfoService.deleteProject",
                    [projectId, revokeStatuses],
                    () => {
                        $(this).trigger("deleteEnd");
                        const projectName = ProjectStore.get(projectId).name;
                        this.actions.toast(messageResource.getMessage("delete.project.toast", [projectName]))
                        this.hidePanel();
                        this.actions.onProjectDeletedCb(projectId)
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        $(this).trigger("deleteEnd");
                        return this._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler)(jqXHR, textStatus, errorThrown)
                    });
        });

        panel.on('cancelDelete', () => {
            panel.openLastSelectedTab()
        });

        panel.on('move', (e, {customer, forceReopen, newWorkflowStatusId}) => {
            const customerId = customer.id;
            newWorkflowStatusId = forceReopen ? null : newWorkflowStatusId
            this._makeUpdateRequest("ProjectInfoService.moveProject",
                    null,
                    [customerId, forceReopen, newWorkflowStatusId],
                    panel.moveToDialog,
                    () => {},
                    (projectId, moveResult) => {
                        let project = ProjectStore.get(projectId)
                        if (project) {
                            const resultProject = moveResult.project
                            ProjectStore.addFirst(resultProject)

                            const projectName = resultProject.name;
                            const customerName = CustomerStore.get(resultProject.customerId).name;
                            panel.setState({name: projectName, active: !resultProject.archived})
                            panel.header.setState({projectName, customerName});
                            this.actions.toast(messageResource.getMessage("move.project.toast", [projectName, customerName]))

                            if (forceReopen) {
                                this.actions(toast(messageResource.getMessage("status.customer.restored.toast", [customerName])))
                            } else if (!!newWorkflowStatusId) {
                                this.actions.toast(messageResource.getMessage("status.project.archived.toast", [projectName]))
                            }

                            if (resultProject.name !== project.name) {
                                this.actions.toast(messageResource.getMessage('move.project.duplicate_name.toast'))
                            }

                            $(this).trigger("projectMoved", [resultProject]);
                            this._handleProjectChanged(resultProject);

                            const resultCustomer = moveResult.customer
                            this._handleCustomerChanged({
                                id: resultCustomer.id,
                                name: resultCustomer.name,
                                archived: resultCustomer.archived,
                            })

                            if (!!newWorkflowStatusId) {
                                this.actions.onProjectArchivedCb(projectId)
                            }
                        }
                        panel.openLastSelectedTab()
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        switch (errorThrown.exception) {
                            case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                                alert(messageResource.getMessage('project.error.move.no_manage_scope_right'))
                                window.location.reload()
                                return true
                            case NO_SUCH_CUSTOMER_EXCEPTION:
                                CustomerStore.remove(customerId)
                                alert(messageResource.getMessage('project.error.move.customer_deleted_concurrently'))
                                panel.moveToDialog.updateSelector()
                                this.actions.onCustomerDeletedCb(customerId)
                                return true
                            case NO_SUCH_PROJECT_EXCEPTION:
                                alert(messageResource.getMessage('project.error.move.project_deleted_concurrently'))
                                window.location.reload()
                                return true
                            case CUSTOMER_UNAVAILABLE_EXCEPTION:
                                alert(messageResource.getMessage('project.error.move.customer_not_available'))
                                window.location.reload()
                                return true
                            case PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                                alert(messageResource.getMessage('project.error.move.project_not_assigned'))
                                window.location.reload()
                                return true
                            case PROJECT_EXISTS_EXCEPTION:
                                alert(messageResource.getMessage('project.error.project_with_same_name_exists'))
                                return true
                            case CUSTOMER_ARCHIVED_EXCEPTION:
                                if (!customer.archived)
                                    alert(messageResource.getMessage("task.error.move.customer_archived"))
                                else
                                    alert(messageResource.getMessage("task.error.move.project_reopened"))
                                window.location.reload()
                                return true
                        }
                        return false;
                    });
        });

        const updateStatusRequest = (active, forceReopenCustomer, forceCompleteTasks, workflowStatusId) => {
            let workflowStatusName = null;
            if (workflowStatusId != null)
                workflowStatusName = unsafe_selectWithState(state => selectStatusById(state, workflowStatusId)).name;

            this._makeUpdateRequest("ProjectInfoService.updateProjectStatus", "status", [active, forceReopenCustomer, forceCompleteTasks, workflowStatusId, workflowStatusName], panel.detailsTab.details.statusButton,
                    () => {
                        panel.detailsTab.details.statusButton.setActive(this.state.status);
                    },
                (projectId, data) => {
                        const project = ProjectStore.get(projectId);
                        if (!active) {
                            panel.setState({active});
                            this.actions.onProjectArchivedCb(projectId)
                            this.changed = true;
                        }
                        else if (forceReopenCustomer) {
                            const customer = _.clone(CustomerStore.get(project.customerId));
                            customer.archived = false;
                            CustomerStore.add(customer);
                            this._handleCustomerChanged(customer);
                        }

                        const projectName = project.name;
                        this.actions.toast(messageResource.getMessage("status.project.toast", [projectName]))
                        panel.openLastSelectedTab();
                        panel.setState({
                            active: active,
                            projectSpentTimeValues: data.projectSpentTimeValues,
                        })
                        this._handleProjectChanged({...project, archived: !active})
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        if (errorThrown.exception === 'com.actimind.actitime.customer.CustomerArchivedException') {
                            if (confirm(messageResource.getMessage('project.error.reopen.customer_archived'))) {
                                panel.detailsTab.details.statusButton.setActive(true);
                                updateStatusRequest(active, true, false, null);
                            }
                            return true;
                        }

                        if (errorThrown.exception === 'com.actimind.actitime.customer.TasksNotArchivedException') {
                            if (isEnabled(Feature.TWS)) {
                                panel.openTabByKey(ProjectPanelDialogs.ARCHIVE_DIALOG)
                                panel.archiveDialog.setState({
                                    openTaskNumber: errorThrown.taskCount,
                                    statusId: unsafe_selectWithState(state => selectFirstStatusByType(state, WorkflowStatusType.COMPLETED)).id
                                });
                            } else {
                                const message = errorThrown.taskCount > 1 ?
                                                messageResource.getMessage("task.error.complete_tasks.project_archive", [errorThrown.taskCount]) :
                                                messageResource.getMessage("task.error.complete_one_task.project_archive");
                                if (confirm(message)) {
                                    panel.detailsTab.details.statusButton.setActive(false);
                                    updateStatusRequest(active, false, true, null);
                                }
                            }
                            return true;
                        }

                        if (errorThrown.exception === "com.actimind.actitime.administration.WorkflowStatusChangedExceptions") {
                            alert(messageResource.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                            window.location.reload();
                            return true
                        }
                        if (errorThrown.exception === "com.actimind.actitime.administration.NoSuchWorkflowStatusException") {
                            alert(messageResource.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                            window.location.reload();
                            return true;
                        }
                        if (errorThrown.exception === "com.actimind.actitime.project.ProjectIsNotAssignedException") {
                            alert(messageResource.getMessage("project.error.cant_change_status.project_not_assigned"));
                            window.location.reload();
                            return true;
                        }
                    });
        };

        panel.archiveDialog.on("archived", (e, id) => {
            updateStatusRequest(false, false, true, id);
        });

        panel.archiveDialog.on("cancel", () => {
            panel.openLastSelectedTab()
        });

        panel.detailsTab.details.statusButton.on('change', (e, active) => {
            updateStatusRequest(active, false, false, null);
        });

        panel.detailsTab.details.auditHistory.on(AuditHistoryView.LoadAuditRecrodsEvent, (event, {offset}) => {
            if (!this.state.allAuditHistoryLoaded || offset === 0) {
                makeRpcCall("ProjectInfoService.getAuditActions",
                        [this.projectId, AuditHistoryView.RECORD_LIMIT, offset],
                        result => {
                            this.setState({
                                allAuditHistoryLoaded: result['auditActions'].list.length < AuditHistoryView.RECORD_LIMIT
                            })
                            if (offset > 0) {
                                panel.detailsTab.details.addAuditRecords(resolveAuditActions(result['auditActions'].list, result['dependencies'].list, AuditEntityTypes['PROJECT']));
                            } else {
                                panel.detailsTab.details.setAuditRecords(resolveAuditActions(result['auditActions'].list, result['dependencies'].list, AuditEntityTypes['PROJECT']))
                            }
                        });
            }
        })

        if (panel.assignedUserTab) {
            panel.assignedUserTab.on('projectTeamChanged', (e, projectTeam) => {
                if (this.updateProjectTeamRequest)
                    this.updateProjectTeamRequest.abort();

                const projectId = this.projectId;

                const customErrorHandler = (jqXHR, textStatus, errorThrown) => {
                    if (projectId !== this.projectId)
                        return false;

                    if (errorThrown.exception === 'com.actimind.actitime.user.NoSuchUsersException') {
                        alert(messageResource.getMessage('project.edit.assigned_deleted_users'));
                        this.hidePanel();
                        return true;
                    }
                    return false;
                };

                this.updateProjectTeamRequest = makeRpcCall("ProjectInfoService.updateProjectTeam",
                        [projectId, projectTeam],
                        () => { },
                        this._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler));
            });
        }

        const updateAssignedUsersErrorHandler = e => {
            if (e instanceof NotFoundError) alert(messageResource.getMessage("project.edit.error.concurrently_deleted"))
            if (e instanceof NoRightsError) alert(messageResource.getMessage("project.error.project_not_assigned"))
            if (e instanceof NoEditHierarchyRightError) alert(messageResource.getMessage("task.list.error.no_manage_scope_right"))
            if (e instanceof NotAssignedError) alert(messageResource.getMessage("task.list.error.user_is_not_assigned_to_manager"))
            if (e instanceof NoSubmitTTRightError) alert(messageResource.getMessage("task.list.error.user_does_not_have_submit_tt_right"))
            if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
            if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))

            window.location.reload()
        }

        const updateManagersErrorHandler = e => {
            if (e instanceof NotFoundError) alert(messageResource.getMessage("project.edit.error.concurrently_deleted"));
            if (e instanceof NoManageUsersRightError) alert(messageResource.getMessage("task.list.error.no_manage_users_right"));
            if (e instanceof NoRightsError) alert(messageResource.getMessage("common.no_rights_for_operation_anymore"))
            if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))
            if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
            if (e instanceof NoAccessToScopeError) alert(messageResource.getMessage("task.list.error.user_does_not_have_any_scope_rights"))
            window.location.reload()
        }

        const assignedUsersEditor = panel.assignedUsersEditorContainer;
        panel.on('assignedUserDelete', (e, {userId}) => {
            applyActionResultToAssignedUsersEditor(
                assignedUsersEditor,
                projectActionsProvider.updateAssignedUsers(this.projectId, [], [userId])
            ).catch(updateAssignedUsersErrorHandler)
        })
        panel.on('assignedUsersChange', (e, {addedUserIds, removedUserIds}) => {
            applyActionResultToAssignedUsersEditor(
                assignedUsersEditor,
                projectActionsProvider.updateAssignedUsers(this.projectId, addedUserIds, removedUserIds)
            ).catch(updateAssignedUsersErrorHandler)
        })

        const managersEditor = panel.managersEditorContainer;
        panel.on('managerDelete', (e, {userData}) => {
            applyActionResultToAssignedUsersEditor(
                managersEditor,
                projectActionsProvider.updateManagers(this.projectId, [], [userData.id])
            ).then(() => {
                    applyActionResultToAssignedUsersEditor(
                        assignedUsersEditor,
                        projectActionsProvider.getAssignedUsers(this.projectId)
                    )
                    const userName = UserNameFormat.formatFML(userData.firstName, userData.lastName, userData.middleName)
                    this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.revoke_manage_project_from_user", [userName]))
            }).catch(updateManagersErrorHandler)
        })
        panel.on('managersChange', (e, {addedUserIds, removedUserIds}) => {
            applyActionResultToAssignedUsersEditor(
                managersEditor,
                projectActionsProvider.updateManagers(this.projectId, addedUserIds, removedUserIds)
            ).then(() => {
                    applyActionResultToAssignedUsersEditor(
                        assignedUsersEditor,
                        projectActionsProvider.getAssignedUsers(this.projectId)
                    )
                }
            ).catch(updateManagersErrorHandler)

            if (removedUserIds.length === 1) {
                const user = managersEditor.state.users.find(u => u.id === removedUserIds[0])
                const userName = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName)
                this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.revoke_manage_project_from_user", [userName]))
            } else if (removedUserIds.length > 1) {
                this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.n_users_no_longer_manage_project", [removedUserIds.length]))
            }
        })
    }

    _updateProjectInStore(projectId) {
        let project = ProjectStore.get(projectId);
        if (project) {
            project = {
                id: projectId,
                customerId: project.customerId,
                name: this.panel.header.nameInput.getName(),
                archived: !this.panel.detailsTab.details.statusButton.isActive()
            }
            ProjectStore.add(project);
        }
        this._handleProjectChanged(project);
    }

    _abortLoadPanelRequest() {
        if (this.loadPanelRequest)
            this.loadPanelRequest.abort();
    }

    loadData(projectId) {
        this._abortLoadPanelRequest();

        this.projectId = projectId;

        const panel = this.panel;
        this.loadingContainer.setState({loading: true})
        panel.header.actions.hideMenu();

        panel.header.nameInput.setLoading(false);
        panel.moveToDialog.setLoading(false);
        panel.copyToDialog.setLoading(false);
        panel.detailsTab.details.statusButton.setLoading(false);
        panel.detailsTab.description.setState({loading: false});

        this.loadPanelRequest = makeRpcCall("ProjectInfoService.getProjectData",
                [projectId],
                data => {
                    const projectFromStore = ProjectStore.get(projectId) ?
                                             _.clone(ProjectStore.get(projectId)) : {id: projectId};
                    const customerFromStore = CustomerStore.get(data.customerId) ?
                                              _.clone(CustomerStore.get(data['customerId'])) : {id: data['customerId']};
                    const receivedProject = _.extend(projectFromStore,
                            {name: data['name'], customerId: data['customerId'], archived: !data['active']});
                    ProjectStore.add(receivedProject)
                    CustomerStore.add(_.extend(customerFromStore, {name: data['customerName']}));

                    // TODO bakharev: update workflow store

                    const deleteData = {
                        blockedDueToLockedTime: data.blockedDueToLockedTime,
                        blockedDueToUnavailableToModifyTimeTrack: data.blockedDueToUnavailableToModifyTimeTrack,
                        canManageAllUsersWithoutAutoApproved: data.canManageAllUsersWithoutAutoApproved,
                        projectHasManagerTimeTrack: data.projectHasManagerTimeTrack,
                        projectHasOtherUsersTimeTrack: data.projectHasOtherUsersTimeTrack,
                        projectHasManagerApprovedTimeTrack: data.projectHasManagerApprovedTimeTrack,
                        projectHasOtherUsersApprovedTimeTrack: data.projectHasOtherUsersApprovedTimeTrack,
                        hasManagerApprover: data.hasManagerApprover,
                    };

                    if (projectId === this.projectId) {
                        this.loadingContainer.setState({loading: false})
                        this.actions.updateEnabledFeatures(arrayToSet(data.enabledFeatures))
                        panel.setState({
                            id: data.id,
                            name: data.name,

                            active: data.active,
                            readOnly: data.readOnly,
                            description: data.description,
                            customerName: data.customerName,
                            assignedUsersData: data.assignedUsersData,
                            assignedUsersDataForManagers: data.assignedUsersDataForManagers,

                            workflowStatuses: data.workflowStatuses,
                            projectSpentTimeValues: data.projectSpentTimeValues,
                            deleteData: deleteData,
                        });
                        this.setState({
                            name: data.name,
                            description: data.description,
                            status: data.active,
                            creationTimestamp: data.creationTimestamp,
                            allAuditHistoryLoaded: false,
                        });
                        this.actions.loadComments()
                        this.getAuditInfo();
                    }

                    this.actions.updateProject(receivedProject)
                    this._onProjectInfoReceivedCb(data)
                },
                this._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId)
        );
    }

    _onProjectInfoReceivedCb(data) {
        this.actions.setAllTasksAssigned(data.allTasksAssigned)
        this.actions.setCanManageProject(!data.readOnly)
    }

    getAuditInfo() {
        if (!this.projectId) return

        const details = this.panel.detailsTab.details;
        details.clearAuditHistory();
        const dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
        const formatDate = (date) => Date.parseJSONTime(date).format(dateFormat)

        makeRpcCall("ProjectInfoService.getLastAuditActionsInfo",
                [this.projectId],
                result => {
                    let createAction = result['createAction'];
                    if (_.isNull(createAction))
                        createAction = {
                            timestamp: this.state.creationTimestamp,
                            type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
                            data: null,
                            subject: null
                        };
                    const updateAction = result['updateAction'];
                    details.setAuditHistory(createAction, updateAction);
                })
    }

    hidePanel() {
        this.panelContainer.setState({isShown: false})
    }

    showPanel() {
        this.panelContainer.setState({isShown: true})
    }

    _getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customHandler) {
        return this._getErrorHandler(projectId, customHandler);
    }

    _getErrorHandler(projectId, customHandler) {
        return _.bind(function(jqXHR, textStatus, errorThrown) {
            if (this.state.openedFromUrl &&  [
                'com.actimind.actitime.project.NoSuchProjectException',
                 'com.actimind.actitime.task.ProjectIsNotAvailableException'].includes(errorThrown.exception)) {
                this.actions.warning(messageResource.getMessage('project.edit_panel.cannot_viewed_from_url'))
                this.hidePanel()
                return true
            }

            if (errorThrown.exception === 'com.actimind.actitime.project.NoSuchProjectException') {
                this.hidePanel()
                alert(messageResource.getMessage("project.error.project_deleted_concurrently"))
                window.location.reload()
                return true
            }
            if (errorThrown.exception === 'com.actimind.actitime.project.ProjectCannotBeModifiedException') {
                alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                this.hidePanel();
                $(this).trigger("projectCannotBeModified");
                return true;
            }
            if (errorThrown.exception === 'com.actimind.actitime.task.ProjectIsNotAvailableException') {
                alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                this.hidePanel();
                this.callbacks.onProjectDeletedCb(projectId)
                return true;
            }

            if (customHandler)
                return customHandler(jqXHR, textStatus, errorThrown);

            return false;
        }, this);
    }

    _handleProjectChanged(project) {
        this.actions.updateProject(project)
        this.changed = true;
    }

    _handleCustomerChanged(customer) {
        this.actions.onCustomerChangedCb(customer)
        this.changed = true;
    }

    updatePanelManagementsAssignmentsState(viewerSettings, managementAssignments) {
        this.panel.setState({
            viewerSettings,
            customersManagementAssignments: managementAssignments.customers
        })
    }

    _makeUpdateRequest(service, stateFieldName, args, targetControl, revertValueFn, customSuccessHandler, customErrorHandler) {
        const projectId = this.projectId;
        const newValue = _.isArray(args) ? args[0] : args;
        targetControl.setLoading(true);
        const setLoadingOfTargetControlToFalseAndCorrectState = newValue => {
            if (_.isUndefined(newValue))
                revertValueFn();
            else if (stateFieldName && !_.isUndefined(this.state[stateFieldName]))
                this.setState({
                    [stateFieldName]: newValue
                })

            targetControl.setLoading(false);
        };
        makeRpcCall(service,
            _.flatten([projectId, [args]]),
            (data) => {
                this._updateProjectInStore(projectId);
                if (projectId !== this.projectId)
                    return true;
                setLoadingOfTargetControlToFalseAndCorrectState(newValue);
                if (customSuccessHandler)
                    customSuccessHandler(projectId, data);
                this.panel.setFakeLastAudit()
            },
            (jqXHR, textStatus, errorThrown) => {
                if (projectId !== this.projectId)
                    return true;
                setLoadingOfTargetControlToFalseAndCorrectState();
                return this._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler)(jqXHR, textStatus, errorThrown);
            });
    }

    _updateDescription(description) {
        this._makeUpdateRequest("ProjectInfoService.updateProjectDescription", "description", description, this.panel.detailsTab.description,
            () => this.panel.setState({description: this.state.description}),
            () => this.panel.setState({description}),
            null
        )
    }
}

export default connect(
    state => ({
        projectId: getOpenProjectId(state),
        openedFromUrl: isPanelOpenedFromUrl(state),

        isWASEnabled: isWASEnabled(state),
    }),
    dispatch => ({
        updateProject: bindActionCreators(updateProject, dispatch),
        onProjectArchivedCb: bindActionCreators(archiveProjectAndReloadTasks, dispatch),
        onProjectDeletedCb: bindActionCreators(removeProject, dispatch),
        onCustomerChanged: bindActionCreators(addCustomer, dispatch),
        onCustomerDeletedCb: bindActionCreators(removeCustomer, dispatch),
        setAllTasksAssigned: bindActionCreators(setAllTasksAssigned, dispatch),
        setCanManageProject: bindActionCreators(setCanManageProject, dispatch),
        loadComments: bindActionCreators(reloadComments, dispatch),
        updateEnabledFeatures: bindActionCreators(setEnabledFeatures, dispatch),
        copyLink: bindActionCreators(copyLinkTo, dispatch),
        toast: bindActionCreators(toast, dispatch),
        warning: bindActionCreators(warning, dispatch),
    }),
)(ProjectPanelController)


// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanelController.js